import { render, staticRenderFns } from "./EmpresaCnpjInput.vue?vue&type=template&id=52480f87"
import script from "./EmpresaCnpjInput.vue?vue&type=script&lang=js"
export * from "./EmpresaCnpjInput.vue?vue&type=script&lang=js"
import style0 from "./EmpresaCnpjInput.vue?vue&type=style&index=0&id=52480f87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports